import { ImageWrapper } from '../../common/wrappers/ImageWrapper';
import image2 from '../../../assets/images/games/m-game/diary.webp';

export default function MDiaryIcon() {
    return (
        <div className="m-continue-button-wrapper">
            <ImageWrapper src={image2} width={60} alt="diary" shouldScroll={true} allowLightbox={false} />
        </div>
    );
}
